export default {
  functionKey: "NOMPROPRE2",
  title: "NOMPROPRE2",
  group: "Texte",
  origin: [],
  target: [],
  description: "Mettre en majuscule la première lettre de chaque phrase",
  isStarred: false,

  generate(destination, origin, args, isArgumentCol) {
    const code = `${destination} = ${origin}.replace(/(?<=^|\\.|\\. |\\?|\\? |\\!|\\! )\\w+/g, function(w) { return w.charAt(0).toUpperCase() + w.slice(1)} );`;
    return { displayCode: code, safeCode: code };
  }
}
